/** CMP BeCompliance — IDs da Kyoto Toyota (toyotakyoto.com.br). */

export const COOKIE_CONSENT_CLIENT_ID = "2544";
export const COOKIE_CONSENT_DOMAIN_ID =
	"4c556f51-0abc-4d13-aa20-23f9e327b591";

export const COOKIE_CONSENT_ID = `${COOKIE_CONSENT_CLIENT_ID}/${COOKIE_CONSENT_DOMAIN_ID}`;

/** Usar `client-side` com hífen; `clientside` retorna 403. */
export const BECOMPLIANCE_CMP_SCRIPT_URL = `https://cdn-api-cmp.becompliance.com/client-side/${COOKIE_CONSENT_ID}.js`;

export const COOKIE_POLICY_PATH = "/cookies";
export const COOKIE_CONSENT_COOKIE_NAME = "BeAliantConsent";
export const COOKIE_PREFERENCES_TRIGGER_ID =
	"cookie-consent-preferences-trigger";
